import { render, staticRenderFns } from "./issue_due_date.vue?vue&type=template&id=0fb65426&"
import script from "./issue_due_date.vue?vue&type=script&lang=js&"
export * from "./issue_due_date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "issue_due_date.vue"
export default component.exports